// =============================================================================
// Feature-Flags des Frontends (zur Build-Zeit aus REACT_APP_* gelesen).
// Sichere Voreinstellung: Die alte offene Registrierung ist aus; /register
// leitet auf die gepruefte Selbstbuchung /selbst-buchen um.
// =============================================================================

const boolFlag = (value, defaultValue) => {
  if (value === undefined || value === null || value === "") return defaultValue;
  return String(value).trim().toLowerCase() === "true";
};

const FEATURES = {
  legacyRegister: boolFlag(process.env.REACT_APP_FEATURE_LEGACY_REGISTER, false),
  // A3 – ALTCHA Proof-of-Work-Bot-Schutz in der Selbstbuchung.
  altcha: boolFlag(process.env.REACT_APP_FEATURE_ALTCHA, false),
  // A5 – tokenbasierte "Passwort festlegen"/Passwort-vergessen-Funktion.
  passwordReset: boolFlag(process.env.REACT_APP_FEATURE_PASSWORD_RESET, false),
};

export default FEATURES;
